/**
 * Grill King — collection/search layout toggle.
 * list | large | dense | split | gallery
 */
(function () {
  'use strict';

  var KEY = 'egj-grid-view';
  var DEFAULT_VIEW = 'dense';
  var VIEWS = {
    list: true,
    large: true,
    dense: true,
    split: true,
    gallery: true
  };
  /* Migrate older density keys */
  var LEGACY = {
    compact: 'split',
    tiny: 'gallery'
  };

  function normalize(view) {
    if (LEGACY[view]) view = LEGACY[view];
    return VIEWS[view] ? view : DEFAULT_VIEW;
  }

  function getView() {
    try {
      return normalize(window.localStorage.getItem(KEY));
    } catch (e) {}
    return DEFAULT_VIEW;
  }

  function setView(view) {
    view = normalize(view);
    var groups = document.querySelectorAll('[data-egj-grid-view]');
    var effectiveView = view;

    groups.forEach(function (group, groupIndex) {
      var available = {};
      group.querySelectorAll('[data-egj-grid]').forEach(function (btn) {
        available[btn.getAttribute('data-egj-grid')] = true;
      });
      var uiView = view;
      if (!available[uiView]) {
        if (available.list && (view === 'large' || view === 'split')) uiView = 'list';
        else if (available.dense) uiView = 'dense';
        else uiView = Object.keys(available)[0] || view;
      }
      if (groupIndex === 0) effectiveView = uiView;
      group.querySelectorAll('[data-egj-grid]').forEach(function (btn) {
        var active = btn.getAttribute('data-egj-grid') === uiView;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });

    document.documentElement.setAttribute('data-egj-grid', effectiveView);
    try {
      window.localStorage.setItem(KEY, effectiveView);
    } catch (e) {}
  }

  function bind() {
    document.querySelectorAll('[data-egj-grid-view]').forEach(function (group) {
      if (group.dataset.egjBound === '1') return;
      group.dataset.egjBound = '1';
      group.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-egj-grid]');
        if (!btn || !group.contains(btn)) return;
        event.preventDefault();
        setView(btn.getAttribute('data-egj-grid'));
      });
    });
  }

  function init() {
    setView(getView());
    bind();
  }

  document.addEventListener('facet:updated', function () {
    bind();
    setView(getView());
  });
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
